<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="70px" :hide-required-asterisk="true">
        <div @keyup.enter.stop="save()">
          <div>{{this.form.specialtyName}}</div>
          <el-form-item label="报名时间" prop="enrollStartTime" class="inline-block" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.enrollStartTime" type="datetime" :picker-options="{disabledDate:disabledDate1}" format="yyyy-MM-dd HH:mm" default-time="00:00:00"></el-date-picker>
          </el-form-item>
          <el-form-item label="至" label-width="40px" prop="enrollEndTime" class="inline-block" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.enrollEndTime" type="datetime" :picker-options="{disabledDate:disabledDate1}" format="yyyy-MM-dd HH:mm" default-time="23:59:00"></el-date-picker>
          </el-form-item>
          <div style="color: #cccccc;">默认为考试设置时间，修改后以专业考试报名为准</div>
          <div style="margin-top: 20px;">
            <el-form-item label="考试时间" prop="examStartTime" class="inline-block" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
              <el-date-picker v-model="form.examStartTime" type="datetime" :picker-options="{disabledDate:disabledDate2}" format="yyyy-MM-dd HH:mm" default-time="00:00:00"></el-date-picker>
            </el-form-item>
            <el-form-item label="至" label-width="40px" prop="examEndTime" class="inline-block" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
              <el-date-picker v-model="form.examEndTime" type="datetime" :picker-options="{disabledDate:disabledDate2}" format="yyyy-MM-dd HH:mm" default-time="23:59:00"></el-date-picker>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">发布</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'edit',
  components: {},
  props: ['dataId'],
  data () {
    return {
      form: null
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {
    'dataId': {
      async handler (newVal, oldVal) {
        await this.initForm(newVal)
      },
      immediate: true
    }
  },
  methods: {
    disabledDate1 (curr) {
      let dis1 = this.$moment(curr).isBefore(this.$moment(this.form.limitStartTime).add(-1, 'day')) || this.$moment(curr).isAfter(this.$moment(this.form.limitEndTime).add(0, 'day'))
      if (this.form.examStartTime && this.form.examEndTime) {
        let dis2 = this.$moment(curr).isAfter(this.$moment(this.form.examEndTime).add(0, 'day'))
        return dis1 || dis2
      } else {
        return dis1
      }
    },
    disabledDate2 (curr) {
      return this.$moment(curr).isBefore(this.$moment(this.form.enrollStartTime).add(-1, 'day'))
    },
    async initForm (dataId) {
      if (dataId) {
        let info = await this.$HTTP.ApiSpecialty.getInfo(dataId)
        if (info.enrollStartTime && info.enrollEndTime) {
          info.enrollStartTime = this.$moment(info.enrollStartTime)
          info.enrollEndTime = this.$moment(info.enrollEndTime)
        } else {
          info.enrollStartTime = this.$moment(info.limitStartTime)
          info.enrollEndTime = this.$moment(info.limitEndTime)
        }
        if (info.examStartTime && info.examEndTime) {
          info.examStartTime = this.$moment(info.examStartTime)
          info.examEndTime = this.$moment(info.examEndTime)
        }
        this.form = info
      } else {
        this.form = {}
      }
      this.$nextTick(() => {
        if (this.$refs['form']) {
          this.$refs['form'].clearValidate()
        }
      })
    },
    async save () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      if (isOK) {
        let confirm = await this.$confirm('确定进行发布吗？', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let info
          let data = {
            specialtyId: this.form.specialtyId,
            enrollStartTime: this.form.enrollStartTime,
            enrollEndTime: this.form.enrollEndTime,
            examStartTime: this.form.examStartTime,
            examEndTime: this.form.examEndTime
          }
          if (this.$moment(this.form.enrollEndTime).isSameOrAfter(this.$moment(this.form.enrollStartTime)) && this.$moment(this.form.examEndTime).isSameOrAfter(this.$moment(this.form.examStartTime))) {
          } else {
            throw new Error('报名结束时间必须大于等于开始时间，且考试结束时间必须大于等于开始时间')
          }
          if (this.$moment(this.form.examStartTime).isSameOrAfter(this.$moment(this.form.enrollStartTime)) && this.$moment(this.form.examEndTime).isSameOrAfter(this.$moment(this.form.enrollEndTime))) {
            if (this.form.specialtyId) {
              info = await this.$HTTP.ApiSpecialty.publish(data)
            }
            this.$emit('close', info)
          } else {
            throw new Error('考试开始时间必须大于等于报名开始时间，且考试结束时间必须大于等于报名结束时间')
          }
        }
      }
    }
  }
}
</script>
